import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, PageContent } from "@/components/layout/PageHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

const emptyImg = "https://images.unsplash.com/photo-1542490101-4be93d1756e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxzb2NjZXIlMjBiYWxsJTIwZGFya3xlbnwwfHx8fDE3ODEzNDU0MDV8MA&ixlib=rb-4.1.0&q=85";

export default function MediaLibrary() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", url: "", type: "image" });

  const load = async () => { const { data } = await api.get("/media"); setItems(data); };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.name || !form.url) { toast.error("Compila i campi"); return; }
    await api.post("/media", form); toast.success("Aggiunto"); setOpen(false); setForm({ name:"", url:"", type:"image" }); load();
  };
  const remove = async (id) => { await api.delete(`/media/${id}`); load(); };
  const copy = (url) => { navigator.clipboard.writeText(url); toast.success("URL copiato"); };

  return (
    <div data-testid="media-page">
      <PageHeader title="Libreria media" subtitle="Gestisci immagini riutilizzabili nei tuoi post.">
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button data-testid="add-media-btn" className="bg-blue-600 hover:bg-blue-700"><Plus size={16} className="mr-1" />Aggiungi media</Button></DialogTrigger>
          <DialogContent className="bg-slate-900 border-slate-800 text-slate-100">
            <DialogHeader><DialogTitle>Aggiungi immagine</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Nome</Label><Input data-testid="media-name" value={form.name} onChange={e=>setForm({...form, name:e.target.value})} className="bg-slate-950 border-slate-800 mt-1" /></div>
              <div><Label>URL immagine</Label><Input data-testid="media-url" value={form.url} onChange={e=>setForm({...form, url:e.target.value})} className="bg-slate-950 border-slate-800 mt-1 font-mono text-xs" placeholder="https://..." /></div>
            </div>
            <DialogFooter><Button onClick={add} data-testid="media-save" className="bg-blue-600 hover:bg-blue-700">Aggiungi</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </PageHeader>
      <PageContent>
        {items.length === 0 ? (
          <div className="border border-dashed border-slate-800 rounded-md p-12 text-center">
            <img src={emptyImg} alt="" className="w-32 h-32 object-cover rounded-md mx-auto opacity-60 mb-4" />
            <div className="text-slate-400">La libreria è vuota.</div>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
            {items.map(m => (
              <div key={m.id} className="bg-slate-900 border border-slate-800 rounded-md overflow-hidden group" data-testid={`media-${m.id}`}>
                <div className="aspect-video bg-slate-950 cursor-pointer" onClick={()=>copy(m.url)}>
                  <img src={m.url} alt={m.name} className="w-full h-full object-cover" />
                </div>
                <div className="p-3 flex items-center justify-between">
                  <div className="text-sm text-white truncate">{m.name}</div>
                  <Button size="sm" variant="ghost" onClick={()=>remove(m.id)} className="h-7 text-red-400"><Trash2 size={13} /></Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </PageContent>
    </div>
  );
}
